// Hierarchical outcome list (Reports "Genel durum" overview). Prefix: qbb-
// A frosted glass card of nested outcome rows: name (+ activity count) on the
// left, a color-coded score pill (high/mid/low, accent tokens) on the right.
// Depth is shown by indentation + a subtle root band — no data-table columns,
// dividers, or symbol headers. The 3-tier score semantics are the product's own.
export const outcomeDetailStyles = `
  .qbb-root {
    overflow: hidden;
    border-radius: var(--rad-catchup-large);
    border: 1px solid var(--glass-flat-border);
    background: var(--glass-flat-solid);
    box-shadow: var(--glass-flat-edge), var(--glass-flat-float-rest);
  }
  .qbb-row-wrapper {
    display: flex;
    flex-direction: column;
  }
  .qbb-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-4);
    padding: 0.85rem 0.9rem;
    border-bottom: 1px solid var(--glass-flat-border);
    transition: background-color var(--duration-base) var(--ease-standard);
  }
  .qbb-row:hover {
    background-color: rgba(84, 187, 203, 0.08);
  }
  /* Root categories get a soft band. */
  .qbb-depth-0 {
    background-color: var(--brand-50);
  }
  /* Category vs outcome. Indent alone did not separate them: "8. SINIF İNKILAP TARİHİ" and a
     outcome sentence rendered as the same row, one step apart, so the tree read as a single flat
     stack. A branch (a row that opens more rows) now takes a faint band and reads as a HEADING;
     a leaf — the outcome itself — stays on white and reads as the CONTENT under it. */
  .qbb-row-branch:not(.qbb-depth-0) {
    background-color: rgba(84, 187, 203, 0.07);
  }
  .qbb-row-leaf:not(.qbb-depth-0) {
    background-color: transparent;
  }
  /* A heading's underline is the top edge of the group it opens, so it carries more weight than
     the hairline between two outcome. Teal, not --glass-border: that token is a translucent WHITE
     and is invisible on these near-white bands. */
  .qbb-row-branch {
    border-bottom-color: rgba(84, 187, 203, 0.38);
  }
  .qbb-info {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    flex: 1 1 0%;
  }
  .qbb-name {
    margin: 0;
    font-size: var(--fs-base);
    line-height: 1.35;
  }
  .qbb-name-root {
    font-weight: 700;
    color: var(--text-primary);
  }
  .qbb-name-sub {
    font-weight: 600;
    color: var(--text-secondary);
  }
  /* The outcome line is what the learner actually reads, so it is the darkest text in the row —
     but the lightest weight, which is what keeps it from competing with the headings above it. */
  .qbb-name-outcome {
    font-weight: 500;
    color: var(--text-primary);
  }
  .qbb-meta {
    margin: 0;
    font-size: var(--fs-md);
    font-weight: 600;
    color: var(--text-muted);
  }
  .qbb-pct {
    flex-shrink: 0;
    min-width: 58px;
    text-align: center;
    font-size: var(--fs-md);
    font-weight: 800;
    font-variant-numeric: tabular-nums;
    padding: 5px 12px;
    border-radius: var(--rad-catchup-full);
  }
  .qbb-score-bg-high {
    background-color: var(--accent-lime-bg);
  }
  .qbb-score-bg-mid {
    background-color: rgba(242, 185, 95, 0.16);
  }
  .qbb-score-bg-low {
    background-color: rgba(226, 91, 91, 0.12);
  }
  .qbb-score-high {
    color: var(--accent-lime-text);
  }
  .qbb-score-mid {
    color: var(--accent-gold-text);
  }
  .qbb-score-low {
    color: var(--color-error);
  }

  /* The row's right cluster: the score pill, plus "Konu Anlatımına Git" on the rows that earn it.
     margin-left:auto keeps it flush right on a WRAPPED line too, where the row's
     justify-content:space-between would otherwise drop it back to the left edge. */
  .qbb-row-end {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: var(--space-3);
    margin-left: auto;
    flex-shrink: 0;
    flex-wrap: wrap;
  }
  /* A row carrying the CTA is a click target, so it says so — the button is the keyboard path, this
     is the "the whole row works" one the güçlü/zayıf cards already taught. It also has to be allowed
     to WRAP: pill + button run ~210px, which at 320px would squeeze the outcome sentence into a
     column two words wide. The 140px floor on the text is what makes the row break instead of crush. */
  .qbb-row-has-cta {
    cursor: pointer;
    flex-wrap: wrap;
    row-gap: var(--space-2);
  }
  .qbb-row-has-cta .qbb-info {
    min-width: 140px;
  }
  .qbb-row-has-cta:hover {
    background-color: rgba(84, 187, 203, 0.14);
  }
  .qbb-cta {
    flex-shrink: 0;
  }
`;
